import { AuditoriaSet } from "src/app/shared/models/auditoria.models";
import { EncuestaEncabezado } from "./encuesta-encabezado";
import { TipoPregunta } from "./tipo-pregunta";
import { CHorario } from "../../horario-trabajo/horario.model";
import { CEncuesta } from "../../formularios-encuesta/models/encuesta.model";
import { RespuestaFormulario } from "../../formularios-encuesta/models/respuesta-formulario";

export class EncuestaFinal {
    encabezado:EncuestaEncabezado = {
        titulo:'',
        codigo_encuesta:'',      
        path_fondo:'',
        path_logo:'',
        horario_disponible: new CHorario(),
        es_vigente:false        
    };    
    tipo_pregunta:TipoPregunta[]=[];
    es_borrado: boolean=false;    
    es_publicado:boolean = false;
    usuario_creacion:string='';
    fecha_creacion?: any;
    ruta_parcial?:string;
    lista_respuesta!:RespuestaFormulario[];    
    //
    id_ref?:string;
    id?:string;
    es_guardado?:boolean;
    //externo
    idEmpresa?:string;
    ruta_completa?:string;
  
}